import type { TMedia } from '@src/shared/types/media';
import type { TLeadNote } from '@src/shared/types/lead-note';
import { date, array, mixed } from 'yup';
import { object } from 'yup';

export const createLeadNoteInitialValues = (note?: TLeadNote) => ({
  note: note ? note.note : '',
  attachments: note ? note.attachments : ([] as TMedia[]),
  next_follow_up_date: note ? note.next_follow_up_date : undefined,
  channel: note ? note.channel : undefined,
});

export const leadNoteFormSchema = object().shape({
  note: mixed().required('Note is required'),
  attachments: array().of(mixed()),
  next_follow_up_date: date()
    .nullable()
    .test(
      'required-with-channel',
      'Next follow-up date is required',
      function (value) {
        const { channel } = this.parent;
        if (channel != null && channel !== '') {
          return value != null;
        }
        return true;
      }
    ),
  channel: mixed()
    .nullable()
    .test('required-with-date', 'Channel is required', function (value) {
      const { next_follow_up_date } = this.parent;
      if (next_follow_up_date != null) {
        return value != null && value !== '';
      }
      return true;
    }),
});

export type TLeadNoteValues = ReturnType<typeof createLeadNoteInitialValues>;
